import helperDate from '$$dateFormatsHelper';
import deadline_icon from '../../../../svg/deadline/deadline_flame.svg';

class Deadline {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.renderDrawDeadline(task),
        getRectangle: (...args) => this.getDeadLineRect(...args),
        getVisibleRange: instance.getVisibleTasksRange,
      },
    });
  }

  getDeadLineRect(item, view) {
    if (!item.deadline) {
      return null;
    }
    let deadline = item.deadline;

    if (typeof item.deadline === 'string') {
      deadline = new Date(item.deadline);
    }

    return {
      top: view.getItemTop(item.id),
      height: view.getItemHeight(item.id),
      left: this.instance.posFromDate(deadline),
      right: this.instance.posFromDate(deadline) + 100,
    };
  }

  renderDrawDeadline(task) {
    if (task.deadline && task.deadline.valueOf()) {
      const viewData = this.instance.ganttDataApi.getActiveProjectData();
      const filterData = viewData && this.instance.ganttDataApi.getCurrentFilter();
      const format = helperDate.getDateFormatForGanttGrid();
      const el = document.createElement('div');
      const sizes = this.instance.getTaskPosition(task, task.deadline);

      el.className = 'deadline';
      el.innerHTML = deadline_icon;

      if (filterData && filterData.properties.rangeDate && filterData.properties.rangeDate.start) {
        el.style.left = `${sizes.left + 2}px`;
      } else {
        el.style.left = `${sizes.left + 8}px`;
      }
      if (task.type === 'project') {
        el.style.top = `${sizes.top + ((this.instance.config.row_height - 36) / 2)}px`;
      } else {
        el.style.top = `${sizes.top + ((this.instance.config.row_height - 26) / 2)}px`;
      }

      let deadline = task.deadline;

      if (typeof task.deadline === 'string') {
        deadline = new Date(task.deadline);
      }
      el.setAttribute('title', this.instance.date.date_to_str(format)(deadline));

      return el;
    }

    return false;
  }
}

export default new Deadline();
